import { InfoCircleFilled } from '@ant-design/icons';
import { CSSProperties, ReactNode } from 'react';
import styles from './index.module.scss';

export const CommonPrompt = (props: {
  type?: 'warn' | 'info';
  children: ReactNode;
  className?: string;
  style?: CSSProperties | undefined;
}) => {
  const { style, children, type = 'info' } = props;
  return (
    <div
      style={style}
      className={`${styles.prompt} ${styles[type]} ${props.className || ''}`}
    >
      <div>
        <InfoCircleFilled />
      </div>
      <div>{children}</div>
    </div>
  );
};
